/* oxlint-disable no-console */
import { Env } from "@/shared/environment";

/**
 * Use the Singleton pattern and an environment variable to log console output only when in dev or beta
 */

export const LoggerService = (function () {
  // oxlint-disable-next-line prefer-const
  let instance;

  if (instance) {
    return instance;
  }

  instance = {
    // oxlint-disable-next-line typescript/no-explicit-any
    log(message?: any, ...optionalParams: any[]) {
      if (
        Env.appEnv === "dev" ||
        Env.appEnv === "beta" ||
        Env.appEnv === "test"
      ) {
        // Suppress lint warnings as console.log itself uses any[] type
        // oxlint-disable-next-line typescript/no-unsafe-argument
        console.log(message, ...optionalParams);
      }
    },
    // oxlint-disable-next-line typescript/no-explicit-any
    error(message: any, errorObject?: any) {
      if (
        Env.appEnv === "dev" ||
        Env.appEnv === "beta" ||
        Env.appEnv === "test"
      ) {
        console.error(message, errorObject);
      }
    },
    // oxlint-disable-next-line typescript/no-explicit-any
    warn(message?: any, ...optionalParams: any[]) {
      if (
        Env.appEnv === "dev" ||
        Env.appEnv === "beta" ||
        Env.appEnv === "test"
      ) {
        // Suppress lint warnings as console.log itself uses any[] type
        // oxlint-disable-next-line typescript/no-unsafe-argument
        console.warn(message, ...optionalParams);
      }
    },
  };

  return instance;
})();
